<template>
    <div class="listing-collections">
     <Swiper
       :slides-per-view="slidesPerView"
       :slides-per-group="slidesPerGroup"
       :spaceBetween="20"
       class="listing-swiper blog_carousel"
       :modules="modules"
       :loop="loop"
       :breakpoints="breakpoints"
       :pagination="{
            dynamicBullets: true, 
            clickable: true
        }"
     >
       <SwiperSlide v-for="item in blog_listing" :key="item.id">
        <ItemBlog :item="item"></ItemBlog>
       </SwiperSlide>
     </Swiper>
   </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import ItemBlog from "./ItemBlog.vue";
import "swiper/css";
   const props = defineProps({
       data: Array,
       breakpoints: Object,
       slidesPerView: Number,
       modules: Array,
       loop: Boolean,
       slidesPerGroup: Number
   })
   const blog_listing = computed(() => props.data || []);

</script>

<style lang="scss">
    @import '@/assets/scss/components/master-template/_master-blogcarousel.scss';
</style>